import { useNavigate, useParams } from "react-router-dom";
import CoreSpinner from "../../../../app/core/components/CoreSpinner/CoreSpinner";
import CoreStatus from "../../../../app/core/components/CoreStatus/CoreStatus";
import {
  useGetDocumentsQuery,
  useGetPracticeByIdQuery,
  useUploadDocumentsPracticeMutation,
} from "../../../api/user/gestisciPraticheApi";
import { t } from "i18next";
import CoreButtonHoverIcon from "../../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import FolderRoundedIcon from "@mui/icons-material/FolderRounded";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import UnarchiveRoundedIcon from "@mui/icons-material/UnarchiveRounded";
import { useState } from "react";
import { toast } from "react-toastify";
import CoreDialog from "../../../../app/core/components/CoreDialog/CoreDialog";
import { useSelector } from "react-redux";
import CoreBack from "../../../../app/core/components/CoreBack/CoreBack";
import CoreTableDocCategory from "../../../../app/core/components/CoreTablePractice/CoreTableDocCategory";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import CoreModal from "../../../../app/core/components/CoreModal/CoreModal";
import Booking from "../../../common/Reservation/Booking";

const SinglePraticaPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const appConfig = useSelector((state) => state.app.appConfig);

  const [isModal, setIsModal] = useState(false);
  const [openReservation, setOpenReservation] = useState(false);

  const { data, isLoading } = useGetPracticeByIdQuery(id);

  const { data: datas, isLoading: Loading } = useGetDocumentsQuery(id);

  const [uploadDocuments, { isLoading: loadingUpload }] =
    useUploadDocumentsPracticeMutation();

  const statusPractice = data?.Data?.status === "InLavorazione";
  const closeActivity =
    data?.Data?.status === "Annullata" ||
    data?.Data?.status === "ChiusaPositivo";

  const handleCloseReservation = () => {
    setOpenReservation(false);
  };

  const handleNavigate = (catId) => {
    return navigate(
      `/auth/user/${t(
        "singlePracticeRoute"
      )}/${id}/documenti?categoria=${catId}`
    );
  };

  const handleUploadDocuments = () => {
    uploadDocuments(id).then((res) => {
      if (res.data.Result === 1) {
        setIsModal(false);
        toast.success("Richiesta inviata");
      } else if (res.data.Exception) {
        toast.error(res.data.Exception);
      }
    });
  };

  if (isLoading) {
    return <CoreSpinner />;
  }

  return (
    <div className="flex flex-col h-full w-full">
      <div className="flex justify-center items-center w-full ">
        <CoreBack />
        <div className="w-11/12 flex items-center justify-between">
          <h2 className="fw-bold">{data?.Data?.name}</h2>
          <h5 className="flex items-center uppercase">
            {t("PracticeStatus")}:{" "}
            <span className="ml-2">
              <CoreStatus status={data?.Data?.status} testo />
            </span>
          </h5>
        </div>
      </div>
      <div className="w-full flex ml-4">
        {appConfig?.modules?.practice?.finishLoadingUser && (
          <CoreButtonHoverIcon
            disabled={statusPractice || closeActivity}
            onClick={() => setIsModal(true)}
            className={`m-1 flex flex-row space-x-2 border ${
              statusPractice || closeActivity ? "text-gray" : "text-yellow-500"
            }`}
            testo={t("FinishLoading")}
            icon={
              <UnarchiveRoundedIcon
                className={`${
                  statusPractice || closeActivity
                    ? "text-gray"
                    : "fill-yellow-500"
                }`}
              />
            }
          />
        )}

        <CoreButtonHoverIcon
          disabled={closeActivity}
          className={
            closeActivity
              ? "text-gray m-1 flex flex-row space-x-2 border"
              : "text-blue-500 m-1 flex flex-row space-x-2 border"
          }
          testo={t("Documents")}
          icon={
            <FolderRoundedIcon
              className={closeActivity ? "fill-gray" : `fill-blue-500`}
            />
          }
          onClick={() =>
            navigate(
              `/auth/user/${t("singlePracticeRoute")}/${id}/${t("documents")}`
            )
          }
        />

        <CoreButtonHoverIcon
          className="text-green-500 m-1 flex flex-row space-x-2 border"
          testo={t("Upload")}
          icon={<UploadFileRoundedIcon className={`fill-green-500`} />}
          onClick={() =>
            navigate(`/auth/user/${t("uploadDocuments")}/`, {
              state: data?.Data?.id,
            })
          }
        />
        {data?.Data?.reservationId && (
          <CoreButtonHoverIcon
            onClick={() => setOpenReservation(true)}
            className="text-blue-700 m-1 flex flex-row space-x-2 border"
            testo={t("Reservation")}
            icon={<CalendarMonthRoundedIcon className={`fill-blue-700`} />}
          />
        )}
      </div>
      <div className="flex w-full mt-5 ml-4 space-x-4">
        <CoreTableDocCategory
          getDocList={datas?.Data}
          onNavigate={handleNavigate}
          status={data?.Data?.status}
        />
      </div>
      <CoreModal
        width={"60%"}
        height={"70%"}
        state={openReservation}
        onClose={handleCloseReservation}
        component={
          <Booking
            spotId={data?.Data?.reservationId}
            practiceId={id}
            serviceCode={data?.Data?.externalCode}
            serviceId={data?.Data?.serviceId}
            onClose={handleCloseReservation}
          />
        }
      />
      <CoreDialog
        open={isModal}
        title={t("FinishLoading")}
        content={t("ConfirmFinishLoading")}
        positiveButton={t("Yes")}
        negativeButton={t("No")}
        handlePositive={handleUploadDocuments}
        closeDialog={() => setIsModal(false)}
        disabledButton={loadingUpload}
      />
    </div>
  );
};

export default SinglePraticaPage;
